var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ep-tabs__row ep-tabs_bg-secondary ep-tabs_rounded-md"},_vm._l((_vm.tabs),function(item,index){return _c('div',{key:index,class:[
      _vm.classes,
      _vm.activeTab() === index ? _vm.activeClass: ''
    ],on:{"click":function($event){return _vm.callback(index)}}},[_vm._t("item",function(){return [_vm._v(" "+_vm._s(item)+" ")]},{"item":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }